import React, { FunctionComponent } from "react";
import { MenuItems, MenuItem } from "../../../../components/@types";
import YaraSelectInput from "./YaraSelectInput";

interface IYaraStringMatchRulesetFilterProps {
  items?: MenuItems;
  active?: MenuItem;
  disabled?: boolean;
  onChange: (value?: MenuItem) => void;
}

const YaraStringMatchRulesetFilter: FunctionComponent<
  IYaraStringMatchRulesetFilterProps
> = ({ items, active, disabled, onChange }) => (
  <YaraSelectInput
    label={"Ruleset"}
    placeholder={"Select Yara Ruleset"}
    allLabel={"All Rulesets"}
    items={items}
    active={active}
    disabled={disabled}
    onChange={onChange}
  />
);

export default YaraStringMatchRulesetFilter;
